module.exports = __webpack_public_path__ + "img/a5.ea78a766.webp";